(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './AuthFlowProvider', './PrivateRoute', './RedirectToLogin', './RedirectToLogout', './withAuthProvider', './token'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./AuthFlowProvider'), require('./PrivateRoute'), require('./RedirectToLogin'), require('./RedirectToLogout'), require('./withAuthProvider'), require('./token'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.AuthFlowProvider, global.PrivateRoute, global.RedirectToLogin, global.RedirectToLogout, global.withAuthProvider, global.token);
    global.index = mod.exports;
  }
})(this, function (exports, _AuthFlowProvider, _PrivateRoute, _RedirectToLogin, _RedirectToLogout, _withAuthProvider, _token) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getToken = exports.withAuthProvider = exports.redirectToSignup = exports.RedirectToSignup = exports.redirectToLogout = exports.RedirectToLogout = exports.redirectToLogin = exports.RedirectToLogin = exports.PrivateRouteGatsby = exports.PrivateRoute = exports.AuthFlowProvider = undefined;

  var _AuthFlowProvider2 = _interopRequireDefault(_AuthFlowProvider);

  var _PrivateRoute2 = _interopRequireDefault(_PrivateRoute);

  var _RedirectToLogin2 = _interopRequireDefault(_RedirectToLogin);

  var _RedirectToLogout2 = _interopRequireDefault(_RedirectToLogout);

  var _withAuthProvider2 = _interopRequireDefault(_withAuthProvider);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.AuthFlowProvider = _AuthFlowProvider2.default;
  exports.PrivateRoute = _PrivateRoute2.default;
  exports.PrivateRouteGatsby = _PrivateRoute.PrivateRouteGatsby;
  exports.RedirectToLogin = _RedirectToLogin2.default;
  exports.redirectToLogin = _RedirectToLogin.redirectToLogin;
  exports.RedirectToLogout = _RedirectToLogout2.default;
  exports.redirectToLogout = _RedirectToLogout.redirectToLogout;
  exports.RedirectToSignup = _RedirectToLogin.RedirectToSignup;
  exports.redirectToSignup = _RedirectToLogin.redirectToSignup;
  exports.withAuthProvider = _withAuthProvider2.default;
  exports.getToken = _token.getToken;
});